import React from 'react'

import { filterValues } from 'utils/object'
import actionFactory from './actionFactory'
import KebabAction from './KebabAction'
import { useSelector } from 'react-redux'

const actionList =
  (model, items: Record<string, Record<string, unknown>>) =>
  (props = {}) =>
    Object.entries(items).map(([name = '??', defaultProps = {}]) => (
      <React.Fragment key={name}>
        {actionFactory(name)({ model, ...defaultProps, ...props })}
      </React.Fragment>
    ))

const listDefaultItems = {
  create: { primary: true },
  export: { kebab: true },
  trash: { kebab: true },
}

export const listActionsFactory = (model, items = listDefaultItems) => {
  const Actions = detailActionsFactory(model, items, 'CardActions')
  return props => {
    const pks = useSelector(model.getSelectedItemIds) as unknown[]
    return <Actions {...props} {...(pks.length ? { pks } : {})} />
  }
}

const detailDefaultItems = { trash: { kebab: true } }

export const detailActionsFactory = (
  model,
  items = detailDefaultItems,
  className = 'DetailActions',
) => {
  const b = filterValues(items, item => !!item?.kebab)
  const a = filterValues(items, item => !item?.kebab)
  const toolActions = actionList(model, a)
  const kebabActions = actionList(model, b)

  const shouldAllowKebabActions = Object.keys(b).length === 0

  return ({ ...props }) => {
    if (props.pk && !props.pks) props.pks = [props.pk]
    return (
      <div className={className}>
        {toolActions(props)}
        {shouldAllowKebabActions || (
          <KebabAction>{kebabActions(props)}</KebabAction>
        )}
      </div>
    )
  }
}
